import React, { useMemo, useEffect } from 'react';
import { Avatar } from '@mui/material';
import { Icon } from "../../../elements";
import { useStore } from "../../../hooks";
import { observer } from "mobx-react";
import {
    ListOfAgentContainer,
    AgentListContainer,
    AgentListCard,
    AgentAvatar,
    AgentData,
    AgentName,
    AgentWelcome
} from './AgentList.styled';

const AgentList = observer(({
    searchTerm = '',
    onAgentClick,
    showDetails = true,
    isExpanded = true
}) => {
    const { authStore } = useStore();
    const { agents } = authStore;

    useEffect(() => {
        if (!agents.length) {
            authStore.fetchAgents();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const listSorted = useMemo(() =>
        agents
            .filter(agent => agent && agent.id)
            .sort((a, b) => {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            })
            .filter(option => (new RegExp(searchTerm, "i")).test(option.name)),
        [searchTerm, agents]
    );

    const renderAgentList = () => {
        return listSorted.map(agent => (
            agent && agent.id && (
                <AgentListCard 
                    className="agentListCard" 
                    onClick={() => onAgentClick(agent)} 
                    key={agent.id}
                >
                    <AgentAvatar title={agent.name} isExpanded={isExpanded}>
                        {agent.photo_url ? (
                            <Avatar 
                                src={agent.photo_url} 
                                alt={`${agent.id}`} 
                                sx={{ width: 32, height: 32 }} 
                            />
                        ) : (
                            <Icon 
                                name="carbonUserAvatarFilled" 
                                height="32px" 
                                width="32px" 
                            />
                        )}
                    </AgentAvatar>
                    {showDetails && (
                        <>
                            <AgentData>
                                <AgentName title={agent.name} data-testid="agent-name">
                                    {agent.name}
                                </AgentName>
                                <AgentWelcome>
                                    {agent.welcome_message}
                                </AgentWelcome>
                            </AgentData>
                        </>
                    )}
                </AgentListCard>
            )
        ));
    };

    return (
        <ListOfAgentContainer className="list-agents">
            <AgentListContainer isExpanded={isExpanded}>
                {renderAgentList()}
            </AgentListContainer>
        </ListOfAgentContainer>
    );
});

export default AgentList;
